import { environment } from 'src/enviroments';
import { HttpHandler } from '../HttpHandler';

export const getStreamChatToken = async (): Promise<string> => {
  const { data } = await HttpHandler({
    method: 'GET',
    url: `${environment.CHAT_APP_API_URL}/client/token`,
  });

  return data.data;
};
